import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { selectorOf } from "../redux-helpers"
import { run } from "../utils"
import { defaultBaseJobInfo, defaultFeedbackJobInfo, IJobInfo } from "./job-info-model"

export const jobInfoSlice = createSlice({
    name: "jobInfo",
    initialState: getJobInfo(),
    reducers: {
        setJobInfo(state, action: PayloadAction<IJobInfo>) {
            return action.payload
        },
        resetState: getJobInfo,
    },
})

export const jobInfoSelector = selectorOf((s) => s.jobInfo)
export const jobActions = jobInfoSlice.actions

/**
 * gets a global object containing info about the job
 */
function getJobInfo(): IJobInfo {
    return (
        // eslint-disable-next-line no-underscore-dangle
        window.__jobInfo ??
        run(() => {
            console.warn("no global job info found. Using defaultJobInfo")
            return { ...defaultBaseJobInfo, ...defaultFeedbackJobInfo }
        })
    )
}
